const project = () => {
  const cards = document.querySelectorAll(".project__card");

  cards.forEach((card) => {
    card.addEventListener("click", (e) => {

      if (e.target.hasAttribute("href")) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      const projectContent = card.querySelector(".project__content");
      const childElements = projectContent.querySelectorAll(
        ".project__subtitle, .project__text, a"
      );

      if (projectContent.classList.contains("active")) {
        childElements.forEach((el) => {
          el.style.opacity = 0;
        });

        setTimeout(() => {
          projectContent.classList.remove("active");

          const button = card.querySelector(".project__more--about");
          if (button) {
            button.textContent = "About the project";
          }
        }, 800);
      } else {
        projectContent.classList.add("active");

        setTimeout(() => {
          childElements.forEach((el) => {
            el.style.opacity = 1;
          });

          const button = card.querySelector(".project__more--about");
          if (button) {
            button.textContent = "Back";
          }
        }, 0);
      }
    });
  });
};

export default project;
